import React from 'react';

import { flagStyles } from '../settings';

const SvgSJ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4776px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSJ;
